export default "__VITE_ASSET__BAenbvdv__"